module.exports = __webpack_public_path__ + "static/media/Info_Icon.566201d7.svg";